import { useAuthQuery } from 'features/common/apiUtils/queryHelper';
import { auditLogsApi } from '../api/endpoints';
import { AuditLogsSystemsResponse } from '../types';
import { AxiosResponse } from 'axios';

export const useGetSystems = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: AxiosResponse<AuditLogsSystemsResponse>) => void;
  onError?: () => void;
}) => {
  const { get_systems } = auditLogsApi;
  const url = get_systems.url();

  return useAuthQuery(
    [url],
    async (axiosInstance) => {
      return axiosInstance?.get<AuditLogsSystemsResponse>(url);
    },
    { onSuccess, onError },
    get_systems.scope,
  );
};
